import { render } from "./VsolEponUplinkTable.vue?vue&type=template&id=0996e1bb&scoped=true"
import script from "./VsolEponUplinkTable.vue?vue&type=script&lang=js"
export * from "./VsolEponUplinkTable.vue?vue&type=script&lang=js"

import "./VsolEponUplinkTable.vue?vue&type=style&index=0&id=0996e1bb&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0996e1bb"]])

export default __exports__